// @flow

import copy from 'copy-to-clipboard';
import * as React from 'react';
import Icon from 'sail/Icon';
import Box from 'sail/Box';
import {UnstyledLink} from 'sail/UnstyledLink';
import {useToast} from 'docs/hooks';
import './InlineCode.scss';

type InlineCodeProps = {|
  content?: string,
  copyable?: boolean,
  children?: React.Node,
|};

export const InlineCode = ({content, copyable, children}: InlineCodeProps) => {
  const [toast, showToast] = useToast();

  const codeContentRef = React.useRef<?HTMLElement>();

  const onCopy = () => {
    if (codeContentRef.current) {
      // Using a ref is the most accurate way to
      // get the text content. `children` is a React element array
      // which needs to get rendered, and `content` is undefined
      // if the Markdoc tag is a {% code %} tag.
      copy(codeContentRef.current.textContent);
      showToast('Copied!');
    }
  };

  if (!copyable) {
    return <code className="InlineCode">{content || children}</code>;
  }

  return (
    <React.Fragment>
      <UnstyledLink
        className="InlineCode-Clipboard InlineCode"
        onClick={onCopy}
        title="Copy to clipboard"
      >
        <code ref={codeContentRef}>{content || children}</code>
        <Icon
          size={14}
          icon="clipboard"
          color="gray300"
          className="InlineCode-CopyIcon"
        />
        {toast && <Box className="CodeBlock-toast">{toast}</Box>}
      </UnstyledLink>
    </React.Fragment>
  );
};
